import { Vue, Component, Prop, Watch, Inject } from "vue-property-decorator";
import uuid4 from "uuid";
import MiniLinkSelect from "./linkSelect.vue";
import style from "./style.vue";
import linkMiniPage from "@/views/components/linkForm/miniPage";
import { EmpServiceAPIActions } from "@/services/empService";
import { appEnvConfig } from "@/configs/appConfigs";
import baseAPIService from "@/services/base/baseAPIService";
import { globalElement } from "@/library/utils/globalElement";
import { noop } from "@/util";
import { Functions } from "@/library/utils/functions";
import LinkForm from "@/views/components/linkForm/linkForm.vue";

// 购物车、点赞、开票说明、联系客服、绑定会员、会员权益、导购认证、选择网点、我的云店、当前版本、我的拼团、活动结果、我的预约、打印商品码、清除缓存、微页面、我的活动
export enum LINK_TYPE {
	CART = 1,
	ZAN,
	INVOICE,
	CUSTOMER_SERVICE,
	BIND_MEMBER,
	MEMBER_SHIP,
	VGUIDER_AUT,
	CHOOSE_SITE,
	MY_SHOP,
	VERSION,
	ASSEMBLE,
	ACT_RESULT,
	SUBSCRIBE,
	PRINT,
	CLEAR_SESSION,
	MINIPAGE,
	MYADDRESS, // 我的地址
	MYACTIVATY, // 我的活动
}

export const morentupian = "https://ssl-picture.tenyun.runsasoft.com/morentupian.jpg";

export const whiteBgIconNav = [
	"",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/icongouwuche.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconwodedianzan.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconkaipiaoshuoming.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconlianxikefu.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconbangdinghuiyuan.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconhuiyuanquanyi.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/icondaogourenzheng.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconqiehuandianpu.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconwodeyundian.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/icondangqianbanben.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconwodepintuan.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconbaomingjieguo.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconwodeyuyue.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/icondayinshangpinma.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconqingkonghuancun.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconweiyemian.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconshouhuodizhi.svg", // 收获地址
	"https://ssl-picture.tenyun.runsasoft.com/theme_1/iconwodehuodong.svg", // 我的活动
];

export const blackBgIconNav = [
	"",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/icongouwuche.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/iconwodedianzan.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/iconkaipiaoshuoming.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/iconlianxikefu.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/iconbangdinghuiyuan.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/iconhuiyuanquanyi.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/icondaogourenzheng.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/iconqiehuandianpu.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/iconwodeyundian.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/icondangqianbanben.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/iconwodepintuan.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/iconbaomingjieguo.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/iconwodeyuyue.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/icondayinshangpinma.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/iconqingkonghuancun.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_4/iconweiyemian.svg",
	"https://ssl-picture.tenyun.runsasoft.com/theme_5/iconshouhuodizhi.svg", // 收获地址
	"https://ssl-picture.tenyun.runsasoft.com/theme_5/iconwodehuodong.svg", // 我的活动
];

export const linkTypes = [
	{
		value: LINK_TYPE.CART,
		label: "购物车",
		url1: whiteBgIconNav[LINK_TYPE.CART],
		url2: blackBgIconNav[LINK_TYPE.CART],
	},
	{ value: LINK_TYPE.ZAN, label: "我的点赞", url1: whiteBgIconNav[LINK_TYPE.ZAN], url2: blackBgIconNav[LINK_TYPE.ZAN] },
	{
		value: LINK_TYPE.INVOICE,
		label: "开票说明",
		url1: whiteBgIconNav[LINK_TYPE.INVOICE],
		url2: blackBgIconNav[LINK_TYPE.INVOICE],
	},
	{
		value: LINK_TYPE.CUSTOMER_SERVICE,
		label: "统一客服",
		url1: whiteBgIconNav[LINK_TYPE.CUSTOMER_SERVICE],
		url2: blackBgIconNav[LINK_TYPE.CUSTOMER_SERVICE],
	},
	{
		value: LINK_TYPE.BIND_MEMBER,
		label: "绑定会员",
		url1: whiteBgIconNav[LINK_TYPE.BIND_MEMBER],
		url2: blackBgIconNav[LINK_TYPE.BIND_MEMBER],
	},
	{
		value: LINK_TYPE.MEMBER_SHIP,
		label: "会员权益",
		url1: whiteBgIconNav[LINK_TYPE.MEMBER_SHIP],
		url2: blackBgIconNav[LINK_TYPE.MEMBER_SHIP],
	},
	{
		value: LINK_TYPE.VGUIDER_AUT,
		label: "导购认证",
		url1: whiteBgIconNav[LINK_TYPE.VGUIDER_AUT],
		url2: blackBgIconNav[LINK_TYPE.VGUIDER_AUT],
	},
	{
		value: LINK_TYPE.CHOOSE_SITE,
		label: "切换店铺",
		url1: whiteBgIconNav[LINK_TYPE.CHOOSE_SITE],
		url2: blackBgIconNav[LINK_TYPE.CHOOSE_SITE],
	},
	{
		value: LINK_TYPE.MY_SHOP,
		label: "我的云店",
		url1: whiteBgIconNav[LINK_TYPE.MY_SHOP],
		url2: blackBgIconNav[LINK_TYPE.MY_SHOP],
	},
	{
		value: LINK_TYPE.VERSION,
		label: "当前版本",
		url1: whiteBgIconNav[LINK_TYPE.VERSION],
		url2: blackBgIconNav[LINK_TYPE.VERSION],
	},
	{
		value: LINK_TYPE.ASSEMBLE,
		label: "我的拼团",
		url1: whiteBgIconNav[LINK_TYPE.ASSEMBLE],
		url2: blackBgIconNav[LINK_TYPE.ASSEMBLE],
	},
	{
		value: LINK_TYPE.ACT_RESULT,
		label: "活动结果",
		url1: whiteBgIconNav[LINK_TYPE.ACT_RESULT],
		url2: blackBgIconNav[LINK_TYPE.ACT_RESULT],
	},
	{
		value: LINK_TYPE.SUBSCRIBE,
		label: "我的预约",
		url1: whiteBgIconNav[LINK_TYPE.SUBSCRIBE],
		url2: blackBgIconNav[LINK_TYPE.SUBSCRIBE],
	},
	{
		value: LINK_TYPE.PRINT,
		label: "打印商品码",
		url1: whiteBgIconNav[LINK_TYPE.PRINT],
		url2: blackBgIconNav[LINK_TYPE.PRINT],
	},
	{
		value: LINK_TYPE.CLEAR_SESSION,
		label: "清除缓存",
		url1: whiteBgIconNav[LINK_TYPE.CLEAR_SESSION],
		url2: blackBgIconNav[LINK_TYPE.CLEAR_SESSION],
	},
	{
		value: LINK_TYPE.MINIPAGE,
		label: "微页面",
		url1: whiteBgIconNav[LINK_TYPE.MINIPAGE],
		url2: blackBgIconNav[LINK_TYPE.MINIPAGE],
	},
	// 新增 我的地址
	{
		value: LINK_TYPE.MYADDRESS,
		label: "收货地址",
		url1: whiteBgIconNav[LINK_TYPE.MYADDRESS],
		url2: blackBgIconNav[LINK_TYPE.MYADDRESS],
	},
	// 新增，我的活动
	{
		value: LINK_TYPE.MYACTIVATY,
		label: "我的活动",
		url1: whiteBgIconNav[LINK_TYPE.MYACTIVATY],
		url2: blackBgIconNav[LINK_TYPE.MYACTIVATY],
	},
];

@Component({
	components: {
		"mini-link-select": MiniLinkSelect,
		LinkForm,
	},
	mixins: [style],
})
export default class IconMenu extends Vue {
	@Prop({ default: () => {} })
	value: DisplayIconMenuData;

	@Prop({ default: false })
	disabled: boolean;

	@Prop({ default: () => [] })
	attrButeList: ItemArray;

	@Prop({ default: 1 })
	themeCode: number;

	@Prop()
	fromPage: number;

	@Inject({ default: 2 })
	mode: number;
	// @Inject()
	// goodsClassList: Function;

	data: DisplayIconMenuData = {};

	isHover = true;

	tokenData: ItemObject = {
		Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
	};

	uuid = "";
	imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

	@Watch("value", { deep: true, immediate: true })
	watchValue(n, o) {
		if (JSON.stringify(n) !== JSON.stringify(o)) {
			this.data = n;
		}
	}

	@Watch("data", { deep: true })
	watchData() {
		this.$emit("input", this.data);
	}

	//  移除图标导航的某一项
	delIconNav(list, index) {
		this.$confirm("确定删除该图标?", { type: "warning" }).then((result) => {
			if (result === "confirm") {
				list.splice(index, 1);
			}
		});
	}

	mounted() {
		this.data.desc.margin = 0;
		this.data.desc.borderRadius = 0;
		this.uuid = uuid4();
	}

	/**
	 * 图片上传成功回调
	 */
	uploadSuccess(res, index) {
		this.data.desc.list[index].url = res.content;
		this.$emit("input", this.data);
	}

	/**
	 * 图片上传之前的格式验证
	 * @param file
	 * @returns {boolean}
	 */
	public beforeAvatarUpload(file) {
		const isJPG = file.type === "image/jpeg";
		const isPNG = file.type === "image/png";
		const isGIF = file.type === "image/gif";
		const isLt300K = file.size / 1024 <= 300;
		if (!isJPG && !isPNG && !isGIF) {
			globalElement.message.error("上传图片只支持 JPG/PNG/GIF 格式!");
		}
		if (!isLt300K) {
			globalElement.message.error("上传图片大小不能超过 300K!");
		}
		return (isJPG || isPNG || isGIF) && isLt300K;
	}

	/**
	 * 图标导航选择链接
	 * 杭俊雅说选择图片后再选择链接，图片置为默认值可以接受
	 */
	changeIconNavPahe(val: number, index) {
		this.data.desc.list[index].page = val;
		this.data.desc.list[index].url = this.themeCode > 3 ? linkTypes[val - 1].url2 : linkTypes[val - 1].url1;
	}

	onLinkChange(val, i) {
		this.data.desc.list[i].linkList[0] ? (this.data.desc.list[i].linkList[0] = val) : this.data.desc.list[i].linkList.push(val);
	}

	// 添加图标导航项
	addIconNav(list) {
		if (this.fromPage === 6) {
			list.push({
				title: "",
				url: "",
				linkList: {
					linkId: 0,
					linkType: 0,
					linkDesc: "",
					couponInfo: {
						cplId: "",
						couponCover: "",
						points: 1,
					},
					jumpPath: {
						appName: "",
						pagePath: "",
					},
					officialAccount: {
						accountTitle: "",
						accountUrl: "",
					},
				},
			});
		} else {
			list.push({
				title: "",
				url: this.themeCode > 3 ? linkTypes[0].url2 : linkTypes[0].url1,
				page: 1,
			});
		}
	}

	dealInput(val, i) {
		this.data.desc.list[i].title = val;
	}

	/**
	 * 是否使用默认边距及圆角
	 * @param {boolean} val
	 */
	useDefault(val, value: IconMenuDesc) {
		this.data.desc.isDefault = val;
		if (val) {
			value.borderRadius = 40;
			value.margin = 24;
		}
	}

	render(h) {
		const hoverIconDefault = linkTypes.filter((vl) => vl.value !== LINK_TYPE.VGUIDER_AUT);
		// if(this.mode === 2){
		//   hoverIconDefault = hoverIconDefault.filter(vl =>(vl.value !== LINK_TYPE.CHOOSE_SITE));
		// }
		const linkPage = (index) => {
			if (this.disabled) {
				return;
			}
			linkMiniPage.open({ sgId: Number(this.$route.params.id), mode: this.mode, siteId: +this.$route.params.siteId }).then((result) => {
				this.$set(this.data.desc.list[index], "pageId", result.id);
				this.$set(this.data.desc.list[index], "pageName", result.name);
				// this.data.desc.list[index].pageId = result.id;
				// this.data.desc.list[index].pageName = result.name;
				this.$forceUpdate();
			}, noop);
		};
		return (
			<div class="container margin-top-none r-ma-20" key={this.data.sort}>
				<el-form props={{ model: this.data }} label-width={"40"} ref="form" disabled={this.disabled} label-position="left">
					<el-radio-group v-model={this.data.desc.type}>
						<el-radio label={1}>九宫格布局</el-radio>
						<el-radio label={2}>列表布局</el-radio>
					</el-radio-group>
					{this.fromPage === 6 && (
						<draggable
							scroll={true}
							v-model={this.data.desc.list}
							scroll-sensitivity={150}
							force-fallback={true}
							draggable=".icon-nav-item"
							preventOnFilter={false}
							filter={".ad-title"}
							// disabled={!this.isHover || this.disabled}
						>
							{this.data.desc.list.map((iconNavItem, index) => {
								return (
									<div class="icon-nav-item" key={this.uuid + index}>
										{!this.disabled && <i class="el-icon-error del-position" onClick={this.delIconNav.bind(this, this.data.desc.list, index)} onMouseenter={() => (this.isHover = false)} onMouseleave={() => (this.isHover = true)} />}
										<el-form-item prop={`desc.list[${index}].url`} rules={[{ required: true, message: "请上传图片", trigger: "change" }]} class="r-mb-0 hei-40">
											<div class="img-div1">
												<img src={iconNavItem.url || morentupian} />
												<el-upload
													class="upload-icon-nav"
													headers={this.tokenData}
													action={this.imgTpConfig}
													data={{ corpId: baseAPIService.resolveCorpId() }}
													showFileList={false}
													style={'color: "#ffffff"'}
													{...{
														props: {
															"on-success": (val) => this.uploadSuccess(val, index),
															"on-error": () => {
																this.$message.error("图片上传错误，请稍后重试！");
															},
														},
													}}
													beforeUpload={this.beforeAvatarUpload}>
													<span class="word">修改</span>
												</el-upload>
											</div>
										</el-form-item>
										<div class="icon-nav-item-edit1">
											<el-form-item
												label="标题"
												class="ad-title"
												prop={`desc.list[${index}].title`}
												// rules={{ required: true, message: " ", trigger: ["blur", "change"] }}
											>
												<el-input v-model={iconNavItem.title} max class="wid-75" maxlength={6} placeholder="请输入标题"></el-input>
											</el-form-item>
											<el-form-item>
												<LinkForm
													value={iconNavItem.linkList}
													empCode={this.$store.state.empCode}
													onInput={(val) => (iconNavItem.linkList = val)}
													state={1}
													sgId={+this.$route.params.sgId}
													siteCodes={[this.$route.params.code]}
													onChange={(val) => this.onLinkChange(val, index)}
													// goodsClassList={this.goodsClassList()}
													linkText="链接"
													ref="linkForm"
													class="hot-ad-link"
													indexIcon={index}
													siteId={+this.$route.params.siteId}
													attributeList={this.attrButeList}
													exclude={[7, 8, 12, 14, 15, 16, 22]}
													mode={this.mode}
													sortShow={+this.mode === 2}
													dialogFooter={+this.mode !== 2}
												/>
											</el-form-item>
										</div>
									</div>
								);
							})}
						</draggable>
					)}
					{!(this.fromPage === 6) && (
						<draggable scroll={true} v-model={this.data.desc.list} scroll-sensitivity={150} force-fallback={true} draggable=".icon-nav-item" filter=".mini-title-icon" preventOnFilter={false} disabled={!this.isHover || this.disabled}>
							{this.data.desc.list.map((iconNavItem, index) => {
								const isLink = iconNavItem.page == LINK_TYPE.MINIPAGE || iconNavItem.page == LINK_TYPE.INVOICE || iconNavItem.page == LINK_TYPE.MEMBER_SHIP;
								return (
									<div class="icon-nav-item" key={iconNavItem.url + iconNavItem.page + index}>
										{!this.disabled && <i class="el-icon-error del-position" onClick={this.delIconNav.bind(this, this.data.desc.list, index)} onMouseenter={() => (this.isHover = false)} onMouseleave={() => (this.isHover = true)} />}
										<el-form-item prop={`desc.list[${index}].url`} rules={[{ required: true, message: "请上传图片", trigger: "change" }]} class="r-mb-0 hei-40" style={`background: ${this.themeCode > 3 ? "#181818" : ""}`}>
											<div style={{ "background-image": `url(${iconNavItem.url}` || `${morentupian})` }} class="img-div">
												<el-upload
													class="upload-icon-nav"
													headers={this.tokenData}
													action={this.imgTpConfig}
													data={{ corpId: baseAPIService.resolveCorpId() }}
													showFileList={false}
													style={`color: ${this.themeCode > 3 ? "#000000" : "#ffffff"}`}
													{...{
														props: {
															"on-success": (val) => this.uploadSuccess(val, index),
															"on-error": () => {
																this.$message.error("图片上传错误，请稍后重试！");
															},
														},
													}}
													beforeUpload={this.beforeAvatarUpload}>
													<p class="word">修改</p>
												</el-upload>
											</div>
										</el-form-item>
										<div class="icon-nav-item-edit">
											<el-form-item label="标题" prop={`desc.list[${index}].title`} rules={{ required: true, message: " ", trigger: ["blur", "change"] }}>
												<el-input v-model={iconNavItem.title} class="mini-title-icon wid-75" max maxlength={6} placeholder="请输入标题"></el-input>
											</el-form-item>
											<el-form-item label="链接" rules={{ required: true, message: " ", trigger: ["blur", "change"] }}>
												<mini-link-select
													value={iconNavItem.page}
													// 导购认证删除
													// 单店个人中心后台装修不提供切换店铺
													hoverIconDefault={hoverIconDefault}
													onChange={(val) => this.changeIconNavPahe(val, index)}
													onMouseenter={(val) => (this.isHover = val)}
													onMouseleave={(val) => (this.isHover = val)}
												/>
											</el-form-item>
											{isLink ? (
												<el-form-item
													prop={`desc.list[${index}].pageName`}
													rules={{ required: true, message: "请选择微页面", trigger: "change" }}
													inline-message={true}
													show-message={!iconNavItem.pageId}
													class={["mini-page-form-item", this.disabled && "disabled"]}>
													<span class="scopeSpan mini-page-link" onMouseenter={() => (this.isHover = false)} onMouseleave={() => (this.isHover = true)} onClick={linkPage.bind(this, index)}>
														{iconNavItem.pageName || "请选择"}
													</span>
												</el-form-item>
											) : (
												""
											)}
										</div>
									</div>
								);
							})}
						</draggable>
					)}
					{!this.disabled && (
						<div class="add-icon-nav">
							<span class="scopeSpan" onClick={this.addIconNav.bind(this, this.data.desc.list)}>
								+ 添加一个图标导航
							</span>
						</div>
					)}
					<el-form-item prop={"desc.list[0]"} rules={{ required: true, message: "请添加图标导航" }}>
						<el-input value={this.data.desc.list.length || ""} v-show={false}></el-input>
					</el-form-item>
					<p class="tip blockTip margin-top-none">注1：&nbsp;建议图片分辨率为150px*150px,不超过300K;</p>
					<p class="tip blockTip margin-top-none">注2：&nbsp;支持jpg、png、gif格式图片;</p>
					<p class="tip blockTip margin-top-none">注3：&nbsp;支持拖动排序;</p>
					<div class="dashed-line"></div>
					{/* <el-row class="icon-item-style">
            <el-col span={6}>区域边距</el-col>
            <el-col span={18}>
              <el-slider
                step={2}
                v-model={this.data.desc.margin}
                min={0}
                max={40}
                onChange={(val) => (this.data.desc.isDefault = false)}></el-slider>
            </el-col>
          </el-row>
          <el-row class="icon-item-style">
            <el-col span={6}>区域圆角</el-col>
            <el-col span={18}>
              <el-slider
                step={2}
                v-model={this.data.desc.borderRadius}
                min={0}
                max={40}
                onChange={(val) => (this.data.desc.isDefault = false)}></el-slider>
            </el-col>
          </el-row>
          <el-row>
            <el-col span={6}>&nbsp;</el-col>
            <el-col span={18}>
              <el-checkbox v-model={this.data.desc.isDefault} onChange={(val) => this.useDefault(val, this.data.desc)}>
                使用建议边距及圆角
              </el-checkbox>
            </el-col>
          </el-row> */}
					{/* <el-row class="icon-item-style">
                <el-col span={6} class="config-title">
                  区域底色
                </el-col>
                <el-col span={6}>
                  <el-color-picker v-model={value.desc.backGround}></el-color-picker>
                </el-col>
                <el-col span={12}>{value.desc.backGround}</el-col>
              </el-row> */}
				</el-form>
			</div>
		);
	}
}
